import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface PrimaryButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function PrimaryButton({
  href,
  children,
  className = ''
}: PrimaryButtonProps) {
  const isCheckout = href.includes('impultienda.ar/checkout');
  function handleClick() {
    if (isCheckout && typeof window !== 'undefined') {
      const pixel = window as Window & {
        fbq?: (event: string, name: string, data?: Record<string, unknown>) => void;
      };
      pixel.fbq?.('track', 'InitiateCheckout', {
        content_name: 'ESL Teacher Ready Complete 6-in-1 System',
        value: 27,
        currency: 'USD'
      });
    }
  }
  return <a href={href} target={isCheckout ? '_blank' : undefined} rel={isCheckout ? 'noopener noreferrer' : undefined} onClick={handleClick} className={`inline-flex items-center justify-center gap-3 rounded-sm border border-gold-100 bg-gold-300 px-6 py-4 text-sm font-bold tracking-wide text-[#16120a] shadow-gold transition hover:bg-gold-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-100 focus-visible:ring-offset-2 focus-visible:ring-offset-ink ${className}`} data-id="element-209">
      {children}
      <ArrowRightIcon size={17} strokeWidth={2.5} aria-hidden="true" data-id="element-210" />
    </a>;
}